import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { CAMPAIGN_CATALOGS } from "./model/campaign-copy.ts";
import { CAMPAIGN_ERROR_COPY } from "./model/campaign-error-copy.ts";

const list = () => import("./ui/sections/campaigns-screen.tsx");
const create = () => import("./ui/sections/new-campaign-screen.tsx");
const wizard = () => import("./ui/sections/campaign-wizard-screen.tsx");
const detail = () => import("./ui/sections/campaign-screen.tsx");

// D206 (ADR-006 §7): every screen and the sidebar entry need "outreach"; off, the screens are
// the not-found screen and the entry is absent, so the area does not exist for the organization.
// The reference serves campaigns under both /emails (its old name) and /campaigns.
export const campaignBrowserModule: BrowserModule = defineBrowserModule("campaign")
  .withErrorCopy(CAMPAIGN_ERROR_COPY)
  .withScreens({
    list: {
      path: "/emails",
      title: phrase(CAMPAIGN_CATALOGS, "listScreenTitle"),
      layout: "app",
      flag: "outreach",
      load: list,
    },
    listAlias: {
      path: "/campaigns",
      title: phrase(CAMPAIGN_CATALOGS, "listScreenTitle"),
      layout: "app",
      flag: "outreach",
      load: list,
    },
    create: {
      path: "/emails/new",
      title: phrase(CAMPAIGN_CATALOGS, "newScreenTitle"),
      layout: "app",
      flag: "outreach",
      load: create,
    },
    createAlias: {
      path: "/campaigns/new",
      title: phrase(CAMPAIGN_CATALOGS, "newScreenTitle"),
      layout: "app",
      flag: "outreach",
      load: create,
    },
    edit: {
      path: "/emails/:campaignId/edit",
      title: phrase(CAMPAIGN_CATALOGS, "editScreenTitle"),
      layout: "app",
      flag: "outreach",
      load: wizard,
    },
    editAlias: {
      path: "/campaigns/:campaignId/edit",
      title: phrase(CAMPAIGN_CATALOGS, "editScreenTitle"),
      layout: "app",
      flag: "outreach",
      load: wizard,
    },
    detail: {
      path: "/emails/:campaignId",
      title: phrase(CAMPAIGN_CATALOGS, "detailScreenTitle"),
      layout: "app",
      flag: "outreach",
      load: detail,
    },
    detailAlias: {
      path: "/campaigns/:campaignId",
      title: phrase(CAMPAIGN_CATALOGS, "detailScreenTitle"),
      layout: "app",
      flag: "outreach",
      load: detail,
    },
  })
  .withNavigation([
    {
      id: "campaigns",
      group: "outreach",
      label: phrase(CAMPAIGN_CATALOGS, "campaigns"),
      href: "/emails",
      icon: "mail",
      order: 200,
      flag: "outreach",
      activeFor: ["/campaigns"],
    },
  ]);
